var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTongyongShouji(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 2.5a.5.5 0 01.5-.5h9a.5.5 0 01.5.5v11a.5.5 0 01-.5.5h-9a.5.5 0 01-.5-.5v-11z",
    stroke: "#3F465C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 11.333h4",
    stroke: "#3F465C",
    strokeLinecap: "round"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTMgMi41QzMgMi4yMjM4NiAzLjIyMzg2IDIgMy41IDJIMTIuNUMxMi43NzYxIDIgMTMgMi4yMjM4NiAxMyAyLjVWMTMuNUMxMyAxMy43NzYxIDEyLjc3NjEgMTQgMTIuNSAxNEgzLjVDMy4yMjM4NiAxNCAzIDEzLjc3NjEgMyAxMy41VjIuNVoiIHN0cm9rZT0iIzNGNDY1QyIvPgo8cGF0aCBkPSJNNiAxMS4zMzMzSDEwIiBzdHJva2U9IiMzRjQ2NUMiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPgo8L3N2Zz4K";
export { SvgTongyongShouji as ReactComponent };